import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        departments: '=',
        roles: '=',
        levels: '=',
        tasklistTemplate: '<'
    },
    template: `
            <div class="well type04">
                <div class="tablewrapper">
                    <list-empty list="vm.form.model.templateTargetsWithValue" show-add-message="true"></list-empty>
                    <table class="data01 col-4" datatable dt-options="vm.DATATABLES" ng-if="vm.form.model.templateTargetsWithValue.length">
                        <thead>
                        <tr>
                            <th>{{ 'courses.Department' | translate }}</th>
                            <th>{{ 'courses.Role' | translate }}</th>
                            <th>{{ 'courses.Level' | translate }}</th>
                            <th>&nbsp;</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr ng-repeat="drl in vm.form.model.templateTargetsWithValue">
                            <td>
                                <span ng-if="drl.departmentName">{{ drl.departmentName }}</span>
                                <span ng-if="!drl.departmentName">{{ 'courses.All departments' | translate }}</span>
                            </td>
                            <td>
                                <span ng-if="drl.roleName">{{ drl.roleName }}</span>
                                <span ng-if="!drl.roleName">{{ 'courses.All roles' | translate }}</span>
                            </td>
                            <td>
                                <span ng-if="drl.levelName">{{ drl.levelName }}</span>
                                <span ng-if="!drl.levelName">{{ 'courses.All levels' | translate }}</span>
                            </td>
                            <td class="actions">
                                <a class="btn edit" ng-style="{ 'height':'30px', 'line-height':'30px', 'margin-top':'0' }"
                                    ng-click="vm.manageTarget(drl)"
                                >{{ 'general.Edit' | translate }}</a>
                                <a class="btn delete" ng-style="{ 'height':'30px', 'line-height':'30px', 'margin-top':'0' }"
                                    ng-click="vm.removeDrl(drl)"
                                >{{ 'general.Remove' | translate }}</a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <a class="btn add" ng-click="vm.manageTarget(null)">{{ 'courses.Add target' | translate }}</a>
                </div>
            </div>
        `
})

export default class {
    constructor ($scope, $state, DATATABLES, COURSE_TARGET_NEED_TYPE_ENUM, TokenService, ModalService, $translate,
        lodash, toastr, ResponseService) {
        this.$scope = $scope;
        this.$state = $state;
        this.TokenService = TokenService;
        this.ModalService = ModalService;
        this.DATATABLES = DATATABLES;
        this.COURSE_TARGET_NEED_TYPE_ENUM = COURSE_TARGET_NEED_TYPE_ENUM;
        this.$translate = $translate;
        this.lodash = lodash;
        this.toastr = toastr;
        this.ResponseService = ResponseService;
    }

    manageTarget (drl, preselectedNeedType = null) {
        const { departments, roles, levels, courseDrlUsers, form, reloadTemplate, $scope, $state, save, removeTargetByKey, lodash, tasklistTemplate } = this;
        return this.ModalService.open({
            size: drl ? 'medium' : 'large',
            template: `
                <modals-tasklist-drl-add
                    ng-if="!vm.drl"
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    departments="vm.departments"
                    roles="vm.roles"
                    levels="vm.levels"
                    form="vm.form"
                    tasklistTemplate="vm.tasklistTemplate"
                />
                <modals-tasklist-drl-edit
                    ng-if="vm.drl"
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    departments="vm.departments"
                    roles="vm.roles"
                    levels="vm.levels"
                    drl="vm.drl"
                    hash-key="vm.hashKey"
                    form="vm.form"
                />`,
            controller ($uibModalInstance) {
                this.$scope = $scope;
                this.$state = $state;
                this.$uibModalInstance = $uibModalInstance;
                this.departments = departments;
                this.roles = roles;
                this.levels = levels;
                this.drl = drl;
                this.hashKey = drl ? drl.$$hashKey : null;
                this.form = form;
                this.courseDrlUsers = courseDrlUsers;
                this.preselectedNeedType = preselectedNeedType;
                this.reloadTemplate = reloadTemplate;
                this.tasklistTemplate = tasklistTemplate;
                this.save = save;
                this.lodash = lodash;
                this.removeTargetByKey = removeTargetByKey;
            }
        });
    }

    removeTargetByKey (hashKey) {
        this.form.model.templateTargets = angular.copy(this.lodash.filter(this.form.model.templateTargetsWithValue, (drl) => {
            return drl.$$hashKey !== hashKey;
        }));
        this.form.model.templateTargetsWithValue = this.form.model.templateTargets;
    }

    save () {
        return this.$scope.$parent.vm.savePromise();
    }

    removeDrl (drl) {
        const message = this.$translate.instant('classifier.Are you sure you wish to remove the target?');
        return this.ModalService.delete(message)
            .then(() => {
                this.removeTargetByKey(drl.$$hashKey);
                this.save().then(() => {
                    this.form.errors = [];
                });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/settings/tasklist/templates/form/target/list/index.js